import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { DoctorRequestDetail } from '../../shared/models/request-doctor-detail.model';
import { FHService } from 'npx-family-happy-common';
import { Subject, takeUntil } from 'rxjs';
import { CommonModule } from '@angular/common';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';

@Component({
  selector: 'app-request-doctor-detail',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './request-doctor-detail.component.html',
  styleUrl: './request-doctor-detail.component.scss',
})
export class RequestDoctorDetailComponent implements OnInit, OnDestroy {
  @Input() inputData!: DoctorRequestDetail;
  @Input() requestID!: number;
  @Input() provincia!: string;
  @Input() reqService!: FHService;
  @Output() dataUpdated = new EventEmitter<DoctorRequestDetail>();

  form!: FormGroup;

  private unsubscribe = new Subject<void>();

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      hoursAmount: [0, [Validators.required, Validators.min(0)]],
      trial: [false],
      serviceStart: [''],
      serviceDuration: [''],
      requiredLanguage: this.fb.group({
        italian: [false],
        english: [false],
      }),
      requestDescription: [''],
      netHourCost: [0, [Validators.min(0)]],
      packageFlatCost: [0, [Validators.min(0)]],
    });

    this.initForm(this.inputData);
    this.form.valueChanges.pipe(takeUntil(this.unsubscribe)).subscribe(() => {
      this.pushDataChanges();
    });
  }

  initForm(requestDetail: DoctorRequestDetail) {
    if (!requestDetail) {
      return;
    }
    this.form.patchValue({
      ...requestDetail,
      requiredLanguage: {
        italian: this.inputData.requiredLanguage
          ? this.inputData.requiredLanguage.includes('IT')
          : false,
        english: this.inputData.requiredLanguage
          ? this.inputData.requiredLanguage.includes('EN')
          : false,
      },
    });
  }

  private pushDataChanges() {
    const data = this.form.value;

    let requiredLanguage: string[] = [];
    Object.entries<boolean>(data.requiredLanguage).forEach((value) => {
      if (value[1]) {
        let langValue = value[0] === 'italian' ? 'IT' : 'EN';
        requiredLanguage.push(langValue);
      }
    });

    const newDoctorInfo: DoctorRequestDetail = {
      ...data,
      requiredLanguage: requiredLanguage,
    };
    this.dataUpdated.emit(newDoctorInfo);
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
